import React, { useMemo } from "react";
import PropTypes from "prop-types";

const Image = ({ wrapperClassName, source, alt, title, ...rest }) => {
	const sources = useMemo(() => source?.sources?.reverse(), [source]);

	return (
		<picture>
			{sources &&
				sources.map((image, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<source key={index} media={image.media} srcSet={image.srcSet} />
				))}
			<img
				className={wrapperClassName}
				src={source?.src}
				srcSet={!source?.src ? source?.srcSet : undefined}
				sizes={source?.sizes}
				alt={alt}
				title={title}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...rest}
			/>
		</picture>
	);
};

Image.propTypes = {
	wrapperClassName: PropTypes.string,
	source: PropTypes.shape({
		aspectRatio: PropTypes.number,
		src: PropTypes.string,
		sources: PropTypes.arrayOf(
			PropTypes.exact({
				media: PropTypes.string,
				srcSet: PropTypes.string,
			})
		),
		sizes: PropTypes.string,
		srcSet: PropTypes.string,
	}),
	alt: PropTypes.string.isRequired,
	title: PropTypes.string,
};

Image.defaultProps = {
	wrapperClassName: undefined,
	title: undefined,
};

export { Image };
